export default {
  companyListInfo: {},
  companyList: [],
  companyTree: {},
  companyInfo: {},
  memberList:[],
  headquarters: [],
}
